<!--
 * @Author: your name
 * @Date: 2020-08-12 15:34:29
 * @LastEditTime: 2022-12-07 17:19:29
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/views/Order/index.vue
-->
<style scoped lang="sass">
$noteColor: rgba(51, 68, 85, 1)
$backGroundColor: #f1f2f3
$textWhiteColor: #fff

.van-button__text
  flex-direction: row

.text
  margin-left: 14px

.touched
  color: $textWhiteColor !important
  background: var(--menu-primary-background-colour) !important

  .icon
    color: $textWhiteColor !important

::v-deep
  .order_item
    border-bottom: 1px solid $backGroundColor

  .van-stepper__input
    font-weight: 500

  .van-button__text
    display: flex
    align-items: center

.app_container
  display: flex
  flex-direction: column
  justify-content: space-between

  .min_delivery_amount
    display: flex
    align-items: center
    margin: 0 14px 14px
    padding: 0 10px
    height: 46px
    background: rgba(176, 6, 32, .1)
    border: 1px solid rgba(176, 6, 32, .3)
    border-radius: 4px

    &.green
      background: rgba(6, 163, 65, .05)
      border: 1px solid rgba(6, 163, 65, .25)

      .condition_icon
        margin-right: 10px
        font-size: 20px
        color: #06A341 !important
        transform: rotate(90deg)

      .min_delivery_amount_text
        margin-left: 0

    .min_delivery_amount_icon
      font-size: 26px
      color: #B00620 !important

    .min_delivery_amount_text
      margin-left: 8px
      font-size: 12px
      list-style: 46px
      color: rgba(0, 0, 0, .75)

  .top
    .order_title
      padding-left: 16px
      color: var(--menu-primary-text-colour)

    .member
      margin-top: 10px

      .member_title
        font-size: 14px
        line-height: 14px
        font-weight: 500
        color: var(--menu-primary-background-colour)

      .member_input
        display: flex
        border: 1px solid rgba(50, 56, 62, .2)
        margin-top: 4px
        border-radius: 4px

        ::v-deep
          .van-cell
            padding: 6px 0 6px 12px
            color: #334455
            border-radius: 4px

      .member_verify
        display: flex
        align-items: center
        margin-top: 6px
        padding: 0 12px
        font-size: 14px
        font-weight: 500
        border-radius: 4px !important
        color: $textWhiteColor !important
        background: var(--menu-primary-background-colour) !important

      .prompt_text
        display: flex
        align-items: center
        margin-top: 10px
        font-size: 12px

        .icon
          margin-right: 6px
          font-size: 14px

      .success_text
        color: #17A341

      .error_text
        color: #B00620

  .content
    display: flex
    flex-direction: column
    padding-top: 25px

    .order_details
      margin-bottom: 12px
      padding: 14px
      color: #334455
      background: rgba(50, 56, 62, .05)
      border-top: 1px solid rgba(51, 68, 85, .1)
      border-bottom: 1px solid rgba(51, 68, 85, .1)

      &.delivery_order_details
        .order_details_item
          .order_details_item_title
            min-width: 60px

      .order_details_header
        display: flex
        font-size: 16px
        font-weight: bold

        .order_details_header_edit
          margin-left: 4px
          color: var(--menu-primary-background-colour)
          cursor: pointer

      .order_details_item
        display: flex
        font-size: 12px

        .order_details_item_title
          margin-right: 4px
          min-width: 70px
          font-weight: bold

    .type
      display: flex
      justify-content: space-between
      align-items: center
      margin-bottom: 25px
      padding: 0 16px

      .dine_in
        flex: 1
        height: 38px
        line-height: 38px
        margin-right: 20px
        border: 1px solid var(--menu-primary-background-colour)
        border-radius: 3px !important
        color: var(--menu-primary-background-colour)

      .take_out
        flex: 1
        height: 38px
        line-height: 38px
        border: 1px solid var(--menu-primary-background-colour)
        border-radius: 3px !important
        color: var(--menu-primary-background-colour)

  .add_note
    height: 56px
    width: 100%
    margin-bottom: 10px
    padding-left: 16px
    font-size: 14px
    line-height: 56px
    background: $backGroundColor
    color: var(--menu-primary-text-colour)

    .font_italic
      font-style: italic

    .color_red
      color: red

  .order_title
    font-size: 16px
    color: $noteColor
    font-weight: 500

  .footer
    height: 56px

.total_price
  font-size: 15px
  color: var(--menu-primary-text-colour)
  text-align: center

  .money
    font-weight: 500

.form
  padding: 0 16px
  margin-bottom: 10px

.comment
  padding: 0 16px
  padding-bottom: 40px

.area
  padding: 0 16px
  margin-top: 15px
  margin-bottom: 40px

.allergy_content
  width: 242px

  .allergy_text
    margin: 26px 0 21px 0
    text-align: center
    font-size: 15px
    color: #334455

  .allergy_img
    display: flex
    justify-content: center

    .img
      width: 57px

  .allergy_btn
    height: 56px
    font-size: 15px

::v-deep
  .van-stepper--round .van-stepper__plus
    background-color: var(--menu-primary-background-colour) !important

  .van-stepper--round .van-stepper__minus
    border-color: var(--menu-primary-background-colour) !important
    background-color: var(--menu-primary-background-colour) !important

  .van-button--primary
    background-color: var(--menu-primary-background-colour)

  .disabled
    background-color: #ddd !important

.tableId_select
  position: relative

.sp_table_delivery_hint
  margin-top: 8px
  font-size: 14px
  color: #B00620

::v-deep
  #textArea
    color: var(--menu-primary-text-colour) !important

  .select.disabled
    background-color: unset !important

  .select
    position: absolute
    top: 23PX
    right: 0
    width: 150PX

    .mu-select
      justify-content: flex-end

    .mu-select-content,
    .mu-input-line,
    .mu-input-focus-line
      display: none

    .mu-select-icon
      width: 24PX
      height: 24PX
      color: #D4D4D4

.sub_total
  display: flex
  flex-direction: column
  padding: 5px 16px
  border-bottom: 1px solid #f1f2f3

  .item
    display: flex
    justify-content: space-between
    align-items: center
    font-size: 12px
    line-height: 22px
    color: var(--menu-primary-text-colour) !important

.currency_warning
  display: flex
  align-items: flex-start
  margin: 10px 14px
  padding: 10px 12px
  background: #FFF8E6
  border: 1px solid #FFD666
  border-radius: 6px

  .warning_icon
    flex-shrink: 0
    width: 20px
    height: 20px
    margin-right: 8px
    background: #FFB800
    border-radius: 3px
    display: flex
    align-items: center
    justify-content: center
    color: #fff
    font-weight: bold
    font-size: 12px

  .warning_content
    flex: 1

    .warning_title
      font-size: 12px
      font-weight: 600
      color: #333
      margin-bottom: 2px

    .warning_text
      font-size: 11px
      color: #666
      line-height: 1.4

.order_recommend
  width: 100%
  height: 132PX
  background: #32383E0D 0% 0% no-repeat padding-box
  opacity: 1

  .title
    text-align: left
    font-size: 12px
    //line-height: 22px
    letter-spacing: 0PX
    color: #000000
    opacity: 0.75
    padding: 5px 16px

  .product_list
    display: flex
    flex-wrap: nowrap
    overflow-x: scroll
    scrollbar-width: none且
    margin-bottom: 10PX
    margin-left: 10PX

::v-deep
  .allergy
    max-height: calc(95vh - 70PX)

    .app_container
      padding: 31px 26px 26px 27px
</style>

<style lang="sass">
body
  .full_width_select
    width: 100% !important

  .tableId_mu_popover.mu-popover
    left: 16px
    width: calc(100vw - 32px)
    max-width: none

    .mu-option.is-selected .mu-item
      color: var(--menu-primary-background-colour)
</style>

<template lang="pug">
.app_container
  await-time(v-if='showAwaitTime && !isOnline', :await-time='awaitTime')
  #scroll_bar.content.overflow_scroll
    // @TODO need to remove twob bird sp settings in future | glasshouse
    py-form.form(
      v-if='number || $store.state.venueId === "b81621f1-5c82-4b97-98dd-93d7b9cdd106" || $store.state.venueId === "fdcc96f2-c145-4dc4-9c6e-8027b4b9c55b" || ($store.state.venueId === "4380f789-c561-4dc7-a510-6f9a48fbb3b9" && !isOnline) || ($store.state.forceTableInput && !isOnline)',
      ref='form',
      :model='valueFields',
      :rules='ruleValidate'
    )
      py-form-item(prop='tableId')
        py-input(
          v-if='!tableList.length',
          :title='tableNumberZoneTitle',
          v-model='valueFields.tableId',
          @input='anewGetTableExtra'
        )
        .tableId_select(v-else)
          py-input(
            :title='tableNumberZoneTitle',
            :disabled="true",
            :value='displayTableId',
            @input='anewGetTableExtra'
          )
          mu-select.select(
            v-model='valueFields.tableId',
            tags,
            :disabled="disableTableSelect"
            popover-class='tableId_mu_popover'
            @change='anewGetTableExtra'
            class="full_width_select"
          )
            mu-option(
              v-for='(item, index) in tableList',
              :key='index',
              :label='formatTableDisplayName(item.name)',
              :value='item.name'
            )
      .sp_table_delivery_hint(v-if='shouldUseSpTableDisplay && displayTableId')
        | {{ tParams('food_delivered_to_seat', 'Food will be delivered to your seat - {tableId}', { tableId: displayTableId }) }}

    .order_details(v-if='isOnline' :class="{ 'delivery_order_details': deliveryInfo.orderType === 'delivery' }")
      .order_details_header
        .order_details_header_title {{ t('order_details', 'Order details') }}
        .order_details_header_edit(
          v-if='showDeliveryEdit',
          @click='showOrderTypeDialog'
        ) {{ t('edit', 'Edit') }}
      .order_details_item
        .order_details_item_title {{ t('order_type', 'Order type:') }}
        .order_details_item_text(style='text-transform: capitalize') {{ deliveryInfo.orderType }}
      .order_details_item
        .order_details_item_title {{ deliveryInfo.orderType === "delivery" ? t('deliver_to', 'Deliver to') : t('pickup_from', 'Pickup from') }}:
        .order_details_item_text {{ deliveryInfo.orderType === "delivery" ? deliveryInfo.address : venueAddress }}
      .order_details_item
        .order_details_item_title {{ deliveryInfo.orderType === "delivery" ? t('estimated_delivery_time', 'Estimated delivery time') : t('pickup_time', 'Pickup time') }}:
        .order_details_item_text {{ deliveryWaitTime | filtersDeliveryWaitTime }}
    // glasshouse wont display dine-in/takeaway otpion
    .type(
      v-if='showOrderType && !number && takeaway === "takeaway" && !isOnline && !$store.state.forceTableInput && $store.state.venueId !== "4380f789-c561-4dc7-a510-6f9a48fbb3b9"'
    )
      van-button.dine_in(
        :class='{ touched: inTouched }',
        @click='inTouchedFun'
      )
        icon.icon restaurant
        span.text {{ t('dine_in', 'Dine-in') }}
      van-button.take_out(
        :class='{ touched: outTouched }',
        @click='outTouchedFun'
      )
        icon.icon local_mall
        span.text {{ t('takeaway', 'Takeaway') }}
    .min_delivery_amount.green(v-if='showCondition && condition.showOffer')
      icon.condition_icon sell
      .min_delivery_amount_text
        span {{ t('spend', 'SPEND') }}
        span.b {{ ` ${symbolPosition === 'after' ? fmtDec(cvt(deliverySurplusAmount)) + ' ' + currencySymbol : currencySymbol + fmtDec(cvt(deliverySurplusAmount))} ` }}
        span {{ t('more_for', 'MORE FOR') }} {{ conditionBaseFee ? (symbolPosition === 'after' ? fmtDec(cvt(conditionBaseFee)) + ' ' + currencySymbol : currencySymbol + fmtDec(cvt(conditionBaseFee))) + ' ' + t('delivery', 'DELIVERY') : t('free_delivery', 'FREE DELIVERY') }}
    .min_delivery_amount(v-if='isSatisfyMinDeliveryAmount')
      icon.min_delivery_amount_icon announcement
      .min_delivery_amount_text {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ cvt(deliverySetting.minDeliveryAmount) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }} {{ t('min_required_delivery', 'min. required for delivery orders.') }}
    .min_delivery_amount(v-if='isNoFreeBreakfasts')
      icon.min_delivery_amount_icon announcement
      .min_delivery_amount_text {{ tableExtraErrorText }}
    .top
      .order_title {{ t('cart_items_title', 'Items:') }}
      order-items.order_item(
        v-for='(item, index) in proList',
        :key='item.id + index',
        :data='item',
        :index='index'
      )
      .order_recommend(v-if='recommendProductList.length > 0')
        .title {{ t('add_something_extra', 'Add something extra:') }}
        .product_list
          recommend-item.p(
            v-for="item in (recommendProductList)"
            :key="item.id"
            :name="getLocalizedProductName(item)"
            :description="getRecommendDescription(item)"
            :descriptionIsHtml="item.settings && item.settings.useHtmlDescription"
            :price="item.price"
            :tags="item.tags"
            :enablePopular="item.enablePopular"
            :quantity="item.num"
            :maskDisplay="!item.status"
            :imgUrl="getLocalizedProductImage(item)"
            :size-settings="item.sizeSettings"
            :hide-price="item.hidePriceInDesc ? item.hidePriceInDesc : false"
            :unavailableText="t('sold_out', 'Sold Out')"
            @add="addProductToCart(item)"
          )

      .sub_total
        .item.o
          div {{ t('subtotal', 'Subtotal:') }}
          div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ cvt(total) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
        .item.o(v-if='discountAmount')
          div {{ spDiscountsCodeText }}
          div {{ symbolPosition === 'after' ? '-' : '-' + currencySymbol }}{{ cvt(discountAmount) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
        .item.o(v-if='paymentSurcharge')
          div {{ surchargeHead }}:
          div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ cvt(publicHolidaySurcharge) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}

        .item.o(v-if='isOnline && deliveryInfo.orderType === "delivery"')
          div {{ t('delivery_fee', 'Delivery fee:') }}
          div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ cvt(baseFee) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
        .item.o(v-if='merchantFee !== 0')
          div {{ t('payment_surcharge', 'Venue Surcharge') }}:
          div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ cvt(merchantFeePrice) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
        .item.b
          div {{ t('total_amount_paid', 'Total amount paid:') }}
          div {{ symbolPosition === 'after' ? '' : currencySymbol }}{{ cvt(totalAll) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
      //- Currency estimate warning banner / 货币估算警告横幅
      .currency_warning(v-if="showCurrencyWarning")
        .warning_icon !
        .warning_content
          .warning_title {{ currencyWarningTitle }}
          .warning_text {{ currencyWarningText }}
      venue-sp-discount(
        :venueSpDiscount='venueSpDiscount',
        :showMemberInput='showMemberInput',
        :verifyMemberState='verifyMemberState',
        :isCodeDiscount='isCodeDiscount',
        :member='memberInfo',
        :isFilledCode="isFilledCode"
        @clickVerifyMemberNum='clickVerifyMemberNum'
        @isMemberInfo="isMemberInfo"
      )
      .add_note(v-show="!disableComment") {{ t('add_a_note', 'Add a note') }}
        span.color_red &nbsp;(
        span.font_italic.color_red {{ t('no_emojis_please', 'no emojis please') }}
        span.color_red )
        span :
    py-text-area#textArea.area(
      v-show="!disableComment"
      v-model='comment',
      v-bind:style='{ height: height + "px" }',
      :label='notePlaceholder',
      :height='height'
    )
  //- 多版本菜单 B6（U-B6-3，owner D56 / D98②）：菜单预览页不能下单 —— 结账按钮变灰，旁边说为什么
  .preview_order_reason(v-if='previewOrderBlocked' role='status') {{ previewOrderReason }}
  footer-bar.footer_bar_absolute(
    :status='status',
    :disabled='jumpButton || (!isVenueOpenTime && !onlineDisabledButton) || (isSatisfyMinDeliveryAmount && isOnline) || hasExpireProduct || isNoFreeBreakfasts || previewOrderBlocked',
    @clickButton='checkCurrentTabOwner'
  )
    template(v-slot:left)
      .total_price
        span {{ t('order_total', 'Order total:') }}
        span.money.ls1 {{ symbolPosition === 'after' ? ' ' : ' ' + currencySymbol }}{{ cvt(totalAll) | fix }}{{ symbolPosition === 'after' ? ' ' + currencySymbol : '' }}
  tab-manage-popup-dialog(
    v-model='showEnablePayShortCutDialog',
    :title='showEnablePayShortCutDialogSettings.title',
    :content='addTabAmount',
    :first-button-text='showEnablePayShortCutDialogSettings.firstButtonText',
    :second-button-text='showEnablePayShortCutDialogSettings.secondButtonText',
    isFlexColumn,
    @clickHandlerFirstButton='handleShortCutDialogOkButton',
    @clickHandlerSecondButton='handleShortCutDialogPayAnotherPayButton'
  )
  tab-manage-popup-dialog(
    v-model='showDisablePayShortCutDialog',
    :title='showDisablePayShortCutDialogSettings.title',
    :content='showDisablePayShortCutDialogSettings.content',
    :first-button-text='showDisablePayShortCutDialogSettings.firstButtonText',
    :second-button-text='showDisablePayShortCutDialogSettings.secondButtonText',
    isFlexColumn,
    @clickHandlerFirstButton='handleShortCutDialogManageMyTabButton',
    @clickHandlerSecondButton='handleShortCutDialogPayAnotherPayButton'
  )
  delivery-info-dialog(
    ref='deliverInfoDialog',
    :title='t("edit_details", "Edit details")',
    :isVenueCloseTime='!isOriginalVenueOpenTime',
    @submit='setDeliveryInfo'
  )

  bottom-popup-dialog.allergy(
    v-model="showAllergyDialog"
    position="center"
    :showCloseIcon="false"
    @changeShow="closeAllergyDialog"
  )
    template(v-slot:popup-dialog)
      .allergy_content
        .allergy_img
          img.img(:src="warningIcon")
        .allergy_text {{ allergyText }}
        van-button.allergy_btn.b.ls1(type="primary" block @click="closeAllergyDialog") {{ t('ok', 'OK') }}
</template>

<script>
import Component, { mixins } from 'vue-class-component'
import mixin from '@/utils/mixin'
import { _numberUpFixed } from '@/utils/number'
import { convertPrice, formatDecimalNumber, getCurrencySymbol, getSymbolPosition, needsConversion, hasMultipleCurrencies, getCurrentCurrencyInfo, getDefaultCurrency } from '@/utils/currency'
import OrderItems from './component/Items'
import AwaitTime from './component/AwaitTime'
import RecommendItem from './component/RecommendItem'
import VenueSpDiscount from './component/venueSpDiscount'
import DeliveryInfoDialog from 'components/DeliveryInfoDialog'
import { addOrder, getTableExtra, getUserOrders, getVenue, otherAction, payOrder, verifyDiscount } from '@/api/product'
import { updateTab } from 'api/tab'
import { mapState } from 'vuex'
import { vuexStoreLoading } from 'utils/decorators'
import * as MessageDict from 'utils/message'
import { delineryAddress } from 'utils/message'
import dayjs from 'dayjs'
import { isIOS } from '@/utils/navigator'
import { MessageDialog } from '@/plugins/createApi'
import resizeHandler from 'utils/resizeHandler'
import { getLocalizedCustomMessage, getLocalizedField, t, tParams } from '@/utils/language'
import { safeDecodeURI } from 'utils'
import { productHasUnpickableRequiredSection } from '@/views/product-detail/utils/productDisplay'
import { surchargeName } from '@/utils/surcharge'
import { trackFunnelEvent } from 'utils/funnelTracking'
import { NO_INPUT_TABLE_NUMBER } from 'utils/constants'
import { orderAmountNow, startSurchargeAutoRefresh } from '@/utils/surchargeSnapshot'
import { deliveryQuote, isLocalDelivery } from '@/utils/deliveryFee'
import { isStoreVenue, menuIdFor, withMenuId, withOrderMenu } from '@/utils/menu/qrMenu'
import { menuEntry } from '@/utils/menu/qrEntry'
import { readWithMenuRetry } from '@/utils/menu/menuRead'
import { reresolveMenu } from '@/utils/menu/reresolveMenu'
import { recheckCartWithMenu } from '@/utils/menu/menuCheck'
import { menuChangedNoticeText } from '@/utils/menu/menuChanged'
import { keepMenuMarks, markAppliesToLine } from '@/utils/menu/cartMarks'
import { createMessageDialog } from '@/utils/request/messageDialog'
import { ORDER_NOT_PLACED, failedOrder, isPlacedOrder, orderOutcomeOf } from '@/utils/orderPlaced'
import { isOrderingBlockedByPreview, stopOrderingForPreview } from '@/utils/menu/previewOrderBlock'
import { withoutQueryKeys } from '@/utils/urlQuery'
import { previewOrdersDisabledText } from '@/utils/menu/previewMenuCopy'

@Component({
  mixins: [resizeHandler],

  requiredComponents: ['vant-base', 'muse-ui', 'vant-form', 'global-popup', 'element-ui'],

  watch: {
    comment() {
      this.getHight()
    },

    vuexDeliveryInfo: {
      handler(val) {
        this.deliveryInfo = val
      },
      immediate: true,
    },

    // If the date or time of deliveryInfo changes, clear the expired products list and pop up the alcohol prompt box
    // 如果 deliveryInfo 的 date 或 time 发生变动，则清空过期商品的列表，并且弹出酒精提示框
    deliveryInfo(newVal, oldVal) {
      if (!newVal.orderType) return
      const popupSettings = this.venueSettings?.customMessageSettings?.popup
      const orderType = newVal.orderType
      const messageEntry = popupSettings ? popupSettings[orderType] : null
      const allergyText = getLocalizedCustomMessage(messageEntry) ?? ''
      if (newVal.preOrderTimeSettings !== oldVal.preOrderTimeSettings) {
        // 多版本菜单 B6（U-B6-2 review 第 2 轮 G4）：「这个时间不行」的标红照今天清掉；本地核对的「不在当前菜单上」（source: menu）跟时间无关
        // （解析出的菜单没变），留着 —— 不然那件不在菜单上的东西当场就能结账、再被后端拒一次。建车菜单也就不用清（第 1 轮那样清了也没人当场重新核对）
        this.$store.commit('saveExpireProductList', keepMenuMarks(this.$store.state.expireProductList))
        this.verifyMemberNum()
        // Judge whether customMessageSettings has a value and whether the switch is on
        // 判断 customMessageSettings 是否有值，并且开关是否开启
        if (messageEntry?.enable) {
          this.allergyText = allergyText.trim() ? allergyText : ''
          // If the corresponding text is empty, the pop-up window will not be displayed
          // 若对应的文案为空，则不展示弹窗
          if (this.allergyText) this.showAllergyDialog = true
        }
      }
      if (newVal.orderType !== oldVal.orderType || newVal.waitTime !== oldVal.waitTime || newVal.address !== oldVal.address) {
        // Judge whether customMessageSettings has a value and whether the switch is on
        // 判断 customMessageSettings 是否有值，并且开关是否开启
        if (messageEntry?.enable) {
          this.allergyText = allergyText.trim() ? allergyText : ''
          // If the corresponding text is empty, the pop-up window will not be displayed
          // 若对应的文案为空，则不展示弹窗
          if (this.allergyText) this.showAllergyDialog = true
        }
      }
    },

    // Are there any expired products in the shopping cart
    // 购物车有没有过期商品
    hasExpireProduct(val) {
      if (!val) this.$store.commit('saveExpireProductList', [])
    },

    // If the membership discount does not exist, clear the previous discount information
    // 若验证会员优惠不存在，则清空之前的优惠信息
    verifyMemberState(val) {
      if (val === 2) this.$store.commit('clearDiscounts')
    },

    // Listen to url query
    // 监听 url query
    $route: {
      handler(val) {
        if (val.query.openDeliveryInfo && this.isOnline) this.showOrderTypeDialog()
      },
      immediate: true,
    },

    // Pre fill it if there is member preference information locally
    // 若本地存有会员优惠信息，则预填写
    spDiscountsCode(val) {
      if (val) {
        this.showMemberInput = 0
        this.memberInfo.memberName = val.split('|')[1] ? val.split('|')[0] : ''
        this.memberInfo.memberNum = val.split('|')[1]
          ? val.split('|')[1]
          : val.split('|')[0]
      }
    },

    // If the shopping cart list changes, recalculate the discount
    // 若购物车列表发生变动，则重新计算优惠
    proList(val) {
      if (val.length) this.verifyMemberNum()
    },

    // If there is no number, clear the table in vuex
    // 若没有 number, 则把 vuex 中的 table 清空
    number: {
      handler(val) {
        if (!val) this.saveTable('')
      },
      immediate: true,
    },
    publicHolidaySurcharge: {
      handler(val) {
        // Save the latest service charge amount in app - details in vuex
        // vuex 中 app - details 数据，保存最新的服务费金额
        this.$store.commit('addDetailsProp', {
          prop: 'surchargeAmount',
          val: parseFloat(val ?? 0),
        })
      },
      immediate: true,
    },
  },

  beforeDestroy() {
    if (this._stopSurchargeAutoRefresh) this._stopSurchargeAutoRefresh()
  },

  async mounted() {
    // 页面开着期间每 30 秒 / 切回前台时按服务器时钟重判附加费，屏幕上的合计跟上时段边界（review 第 1 轮 #4）
    this._stopSurchargeAutoRefresh = startSurchargeAutoRefresh(this.$store)
    // If query - portal === 'true', hide the option of selecting order type
    // 若 query - portal === 'true'，则隐藏选择订单类型选项
    if (this.$route.query.portal === 'true') this.showOrderType = false
    // @TODO need to remove after add option to lock table no
    if (
      this.venueId === 'b81621f1-5c82-4b97-98dd-93d7b9cdd106' ||
        this.venueId === 'fdcc96f2-c145-4dc4-9c6e-8027b4b9c55b' ||
        this.$store.state.forceTableInput
    ) {
      if (!this.number) {
        this.number = ''
      }
    }
    await this.__checkVenueOpenTime()
    this.$store.commit('showLoading')
    await this._filterAndSaveUnfinishOrder()
    this._getNumber()
    if (this.takeaway === 'takeaway') {
      this.outTouched = false
      this.inTouched = true
    }
    const orderType = localStorage.getItem('orderType')
    if (orderType) {
      this.outTouched = true
      this.inTouched = false
    }
    this.addListen()
    if (this.venueSpDiscount && this.venueSpDiscount.enable) {
      // If spDiscountsCode has been saved, assign the value again
      // 若保存过 spDiscountsCode，则再次赋值
      if (this.spDiscountsCode) {
        this.showMemberInput = 0
        this.memberInfo.memberName = this.spDiscountsCode.split('|')[1]
          ? this.spDiscountsCode.split('|')[0]
          : ''
        this.memberInfo.memberNum = this.spDiscountsCode.split('|')[1]
          ? this.spDiscountsCode.split('|')[1]
          : this.spDiscountsCode.split('|')[0]
        this.$nextTick((_) => {
          this.verifyMemberNum()
        })
      }
    }
    if (this.$route.query.openDeliveryInfo) this.showOrderTypeDialog()
    if (this.venueIsGuests) this._getTableExtra()
    await this._getCartRecommend() // get recommend list (includes AI recommendations from backend)
    await this._getVenue()

    // If the routing query contains ta, the order type is set to takeaway
    // 若路由 query 中带有 'ta'，则订单类型设置为 takeaway
    if ('ta' in this.$route.query && !(this.venueSettings?.dineInSettings?.enableTakeaway === false)) {
      localStorage.setItem('orderType', 'takeaway')
      this.$store.commit('addDetailsProp', {
        prop: 'orderType',
        val: 'takeaway'
      })
    }

    await this._setDeliveryCost()
    this.$store.commit('closeLoading')
    // 多版本菜单 B6（D97；U-B6-2 review 第 1 轮 F6）：store 里的菜单 ≠ 建车菜单 ⇒ 按这份菜单本地核对一次。
    // 放在页面自己的数据都读完、关了加载圈之后，**不等它**：它要读一整份商品表（大店很慢），只是标几行、提示一句，不该挡住购物车页
    // （也在购物车推荐之后：推荐那一步可能静默重新解析了菜单）
    this._recheckCartMenu()
    if (this.$openreplayTracker) this.$openreplayTracker.event('view_cart')
    if (this.$gtag) {
      this.$gtag.event('view_cart', {
        event_category: 'purchase_journey',
        event_label: 'View Cart',
      })
    }
  },

  props: {
    number: [String, Number],
  },

  filters: {
    fix(val) {
      return _numberUpFixed(val)
    },

    filtersDeliveryWaitTime(val) {
      return dayjs(val).format('dddd, DD/MM/YYYY,HH:mm')
    }
  },

  components: {
    OrderItems,
    AwaitTime,
    DeliveryInfoDialog,
    VenueSpDiscount,
    RecommendItem
  },

  computed: {
    // Currency symbol for display / 显示用的货币符号
    currencySymbol() {
      const _c = this.currentCurrency // eslint-disable-line no-unused-vars
      return getCurrencySymbol()
    },

    // Symbol position for display / 符号位置
    symbolPosition() {
      const _c = this.currentCurrency // eslint-disable-line no-unused-vars
      return getSymbolPosition()
    },

    // Whether to show currency estimate warning / 是否显示货币估算警告
    showCurrencyWarning() {
      const _c = this.currentCurrency // eslint-disable-line no-unused-vars
      return hasMultipleCurrencies() && needsConversion()
    },

    // Currency warning title text / 货币警告标题文本
    currencyWarningTitle() {
      const _c = this.currentCurrency // eslint-disable-line no-unused-vars
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      const currencyInfo = getCurrentCurrencyInfo()
      const currencyName = currencyInfo.name || currencyInfo.code
      return tParams('currency_estimate_warning', 'Prices shown in {currency} are an estimate only.', {
        currency: currencyName,
      })
    },

    // Currency warning detail text / 货币警告详情文本
    currencyWarningText() {
      const _c = this.currentCurrency // eslint-disable-line no-unused-vars
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      const defaultCurrency = getDefaultCurrency()
      return tParams(
        'currency_charge_notice',
        'You\'ll be charged in {defaultCurrency}. Your bank may apply a different exchange rate and fees.',
        { defaultCurrency }
      )
    },

    // Table number/zone title - reactive to language changes
    // 桌号/区域标题 - 响应语言变化
    tableNumberZoneTitle() {
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      return t('table_number_zone', 'Table number/zone')
    },

    // Add note placeholder - reactive to language changes
    // 添加备注占位符 - 响应语言变化
    notePlaceholder() {
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      return t('add_note_here', 'Add note here')
    },

    ...mapState({
      currentLanguage: state => state.language?.currentLanguage,
      currentCurrency: state => state.currencySettings?.currentCurrency,
      expireProductList: (state) => state.expireProductList,
      spDiscounts: (state) => state.spDiscounts,
      spDiscountsCode: (state) => state.spDiscountsCode,
      isOnline: (state) => state.app.isOnline,
      paymentSurcharge: (state) => state.app.paymentSurcharge,
      paymentSurchargeSettings: (state) => state.app.paymentSurchargeSettings,
      onlineDisabledButton: (state) => state.app.onlineDisabledButton,
      vuexDeliveryInfo: (state) =>
          state.contactDetails?.deliveryInfo[state.venueId] ?? {},
      userInfo: (state) => state.contactDetails.user,
      venueAddress: (state) =>
        state.venueHome.pickupSettings &&
          state.venueHome.pickupSettings.pickupAddress &&
          state.venueHome.pickupSettings.pickupAddress !== ''
          ? state.venueHome.pickupSettings.pickupAddress
          : state.venueHome.address,
      venueSpDiscount: (state) => state.venueHome.spDiscount,
      venueIsGuests: (state) => state.venueHome.isGuests,
      deliverySetting: (state) => state.venueHome.deliverySetting,
      discountRules: (state) => state.venueHome.discountRules,
      routerInfo: (state) => state.venueHome.routerInfo,
      venueGroupSettings: (state) => state.venueHome.venueGroupSettings
    }),

    tabInfo() {
      return this.$store.getters.tabInfo(this.venueId)
    },

    disableComment() {
      return this.venueGroupSettings?.disableGroupComment ?? false
    },

    disableTableSelect() {
      return this.venueGroupSettings?.disableTableSelect ?? false
    },

    // When picking only, you are not allowed to edit the order details
    // pick only 时，不允许编辑订单详情
    showDeliveryEdit() {
      const enablePickup =
          this.venueSettings?.pickupSettings?.enableTakeaway ??
          this.venueSettings?.options?.takeaway ??
          false
      const enableDelivery =
          this.venueSettings?.deliverySettings?.enableDelivery ?? false
      const enablePreOrder =
          this.venueSettings?.preOrderSettings?.enable ?? false
      return !(enablePickup && !enableDelivery && !enablePreOrder)
    },

    /**
     * Delivery, whether to display Condition
     * @returns {boolean} Show Results
     */
    /**
     * delivery，是否显示 Condition
     * @returns {boolean} 显示结果
     */
    showCondition() {
      // 只有本地配送有档位（缺 type 照后端 getBaseFee 算第三方，见 utils/deliveryFee.js isLocalDelivery）
      const isLocal = isLocalDelivery(this.deliverySetting)
      const conditionRule = this.deliverySetting?.conditionRule ?? []
      this.condition = conditionRule[0]
      const conditionBaseFee = Number(this.condition?.baseFee ?? 0)
      if (conditionBaseFee < this.baseFee) {
        this.conditionBaseFee =
            conditionBaseFee > this.baseFee ? this.baseFee : conditionBaseFee
      }
      return (
        this.isOnline &&
          this.deliveryInfo.orderType === 'delivery' &&
          isLocal &&
          this.condition &&
          !this.isSatisfyMinDeliveryAmount &&
          this.deliverySurplusAmount > 0
      )
    },

    /**
     *  Delivery, how much money is left to reach the minimum amount of Condition
     * @returns {number} amount of money
     */
    /**
     *  delivery，还剩多少钱能达到 Condition 的最低金额
     * @returns {number} 金额
     */
    deliverySurplusAmount() {
      return Number(this.condition?.minDeliveryAmount ?? 0) - Number(this.total)
    },

    baseFee() {
      const vuexDeliveryInfo = this.$store.state.contactDetails?.deliveryInfo[this.$store.state.venueId] ?? {}
      // 与后端 AddOrderForm::getBaseFee 同义（utils/deliveryFee.js deliveryQuote）：
      // type 不是 'local'（含缺 type）一律按第三方 —— 费用是第三方报价，没有报价后端按 0 收（review 第 1 轮 #6）；
      // 只有本地配送看档位，看全部 conditionRule，最后一条满足的赢（H3 / UL-9）
      const quote = deliveryQuote(this.deliverySetting, vuexDeliveryInfo, this.total)
      this.$store.commit('addDeliveryInfo', {
        ...vuexDeliveryInfo,
        minDeliveryAmount: quote.minDeliveryAmount,
        conditionBaseFee: quote.conditionBaseFee,
      })
      this.minDeliveryAmount = quote.minDeliveryAmount
      return quote.baseFee
    },

    isNoTable() {
      return this.routerInfo?.noTable ?? false
    },

    buttonColor() {
      return this.$store.state.app.color.menu_primary_background_colour
    },

    // 多版本菜单 B6（U-B6-2 review 第 2 轮 G3）：一条标记算不算在某一行上看 markAppliesToLine —— 本功能写的标记（带 source）
    // 不算在店家强塞的行上（顾客删不掉它，不然删了自己那一行按钮还是灰的）；老标记照今天按 id
    hasExpireProduct() {
      return !!this.expireProductList.find((expire) =>
        this.proList.find((item) => markAppliesToLine(expire, item)),
      )
    },

    deliveryWaitTime() {
      return this.deliveryInfo.preOrderTimeSettings &&
      this.deliveryInfo.preOrderTimeSettings !== 'Invalid Date'
        ? this.deliveryInfo.preOrderTimeSettings
        : dayjs.tz().add(this.deliveryInfo.waitTime, 'minute')
    },

    isSatisfyMinDeliveryAmount() {
      const minDeliveryAmount = Number(this.deliverySetting.minDeliveryAmount)
      const amount = Number(this.total) - Number(this.discountAmount) + Number(this.publicHolidaySurcharge)
      return (
        this.isOnline &&
          this.deliveryInfo.orderType === 'delivery' &&
          minDeliveryAmount > amount
      )
    },

    // Whether there is no free breakfast
    // 是否没有免费早餐
    isNoFreeBreakfasts() {
      // Whether the shopping cart has free breakfast
      // 购物车是否有免费早餐
      const hasFreeBreak = Boolean(
        this.proList.find((item) => item.id === this.tableExtra?.FreeItemId),
      )
      if (!this.tableExtra || !hasFreeBreak) return false
      const freeBreakList = this.proList.filter(
        (item) => item.id === this.tableExtra?.FreeItemId,
      )
      let freeBreakNum = 0
      if (freeBreakList?.length) {
        freeBreakList.forEach((item) => {
          freeBreakNum += item.num
        })
      }
      // Remaining times for users to order free breakfast
      // 用户可以点免费早餐的剩余次数
      const remainderNum =
          Number(this.tableExtra.noOfFreeItem) -
          Number(this.tableExtra.noOfUsedFreeItem)
      if (remainderNum <= 0) {
        this.tableExtraErrorText = t('no_breakfast_remaining', 'You have no included breakfast remaining. Please remove these items from your cart.')
        return true
      }
      if (freeBreakNum > remainderNum) {
        this.tableExtraErrorText = tParams('only_breakfast_remaining', 'You only have {count} included breakfast remaining. Please remove some items to place your order.', { count: remainderNum })
        return true
      }
    },

    addItemList() {
      const itemList = this.$store.getters
        .itemList(this.venueId)
        .map((item) => {
          if (item.comboProducts) {
            return {
              ...item,
              // ComboProducts needs to remove the modifications
              // comboProducts 需要去掉配菜
              comboProducts: this.deleteDuplicate(
                item.comboProducts.filter((e) => e.type !== 'optional'),
                item.addList.filter(
                  (item) =>
                    item.type !== 'oneProduct' && item.type !== 'optional',
                ),
                item.removeList,
              ),
              addList: item.addList.filter(
                (item) => item.type !== 'oneProduct',
              ),
            }
          } else {
            return item
          }
        })
      return itemList
    },

    merchantFeePrice() {
      return this.$store.getters.merchantFeePrice(this.venueId)
    },

    totalAll() {
      return this.$store.getters.realPrice(this.venueId)
    },

    discountAmount() {
      return this.$store.state.discountAmount
    },

    merchantFee() {
      return this.$store.state.app.merchantFee
    },

    jumpButton() {
      return !(this.proList.length > 0)
    },

    // 多版本菜单 B6（U-B6-3）：地址里带着菜单预览码 ⇒ 不能下单（依赖 $route，跳转后重算）
    previewOrderBlocked() {
      return isOrderingBlockedByPreview(this.$route)
    },

    previewOrderReason() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return previewOrdersDisabledText()
    },

    /**
     * @returns {Number} Public holiday surcharge amount
     */
    /**
     * @returns {Number} 公共假日附加费的金额
     */
    publicHolidaySurcharge() {
      return this.$store.getters.publicHolidaySurcharge(this.venueId)
    },

    surchargeHead() {
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      const WEEKDAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
      const s = this.paymentSurchargeSettings
      if (this.paymentSurcharge > 0 && s !== '' && s && s.type === 'date') {
        return surchargeName({ type: 'date', group: s.settings && s.settings.group, settings: s })
      }
      if (this.paymentSurcharge > 0 && s !== '' && s && s.type === 'weekly') {
        // 用判定费率时（门店时区、服务器时钟）的那个星期，不用手机时钟再算一遍
        return surchargeName({ type: 'weekly', weekDay: s.weekDay || WEEKDAYS[dayjs.tz().day()], settings: s })
      }
      // No settings / legacy: fall back to today's weekday surcharge
      return surchargeName({ type: 'weekly', weekDay: WEEKDAYS[dayjs.tz().day()] })
    },

    total() {
      return this.$store.getters.total(this.venueId)
    },

    proList() {
      return this.$store.state.productList.filter(
        (item) => item.venueId === this.venueId,
      )
    },

    table() {
      return this.$store.state.table
    },

    takeaway() {
      // The takeaway here is not a real takeaway passed to the interface, but an identifier to determine whether takeaway is allowed. The real change depends on the takeaway in the locaStorage
      // 这里的 takeaway 不是真实的传给接口的 takeaway，而是一种标识符，来判断是否允许 takeaway，真正的改变根据 locaStorage 中的 takeaway 决定
      return this.$store.state.details.orderType
    },

    venueId() {
      return this.$store.state.venueId
    },

    padding() {
      return this.$store.state.app.request
    },

    isPostPaid() {
      return this.$store.state.venueHome.routerInfo.paymentType === 'post-paid'
    },

    userId() {
      return localStorage.getItem('userId')
    },

    showAwaitTime() {
      return this.waitingTimeSetting?.enableWaitingTime
    },

    awaitTime() {
      return this.waitingTimeSetting?.awaitingTime / 60
    },

    isTabOwner() {
      return !!this.tabInfo?.currentTab?.id
    },

    isPrePaidOrder() {
      return this.$store.state.venueHome.routerInfo.paymentType === 'pre-paid'
    },

    addTabAmount() {
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      const amount = _numberUpFixed(
        Number(this.tabInfo?.currentTab?.amount ?? 0) + Number(this.totalAll),
      )
      const symbol = getCurrencySymbol()
      const position = getSymbolPosition()
      const priceStr = position === 'after' ? `${amount} ${symbol}` : `${symbol}${amount}`
      return tParams('your_tab_will_be', 'Your tab will be {price}.', { price: priceStr })
    },

    isCodeDiscount() {
      // Determine whether the type is a code type. Compatible with old data. If the interface has no type, it defaults to membership
      // 判断 type 是否是 code 类型。兼容老数据，接口如果没有 type 时，默认是 membership
      return (this.venueSpDiscount?.type ?? 'membership') === 'code'
    },

    isSpMode() {
      return this.$route.path.includes('/v/sp/') || this.$route.meta?.isSpMode === true
    },

    /**
     * Whether to use the special table display format (Row -> Seat)
     * 是否使用特殊的桌号显示格式（Row -> Seat）
     * @returns {Boolean}
     */
    shouldUseSpTableDisplay() {
      const targetVenueId = '67588b97-4709-498b-8543-19dc15ba007b'
      return this.isSpMode && this.venueId === targetVenueId
    },

    /**
     * Display value for table ID (converts Row to Seat for display only)
     * 桌号显示值（仅在显示时将 Row 转换为 Seat）
     * @returns {String}
     */
    displayTableId() {
      return this.formatTableDisplayName(this.valueFields.tableId)
    },

    /**
     * @return {String} Discount copywriting
     */
    /**
     * @return {String} discount 文案
     */
    spDiscountsCodeText() {
      const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
      let text = t('member_discount', 'Member discount:')
      if (!this.spDiscountsCode || this.isCodeDiscount) text = t('discount', 'Discount:')
      return text
    },
  },
})

class Order extends mixins(mixin) {
  // Format decimal number with correct separator / 使用正确的小数点分隔符格式化数字
  fmtDec(val) { return formatDecimalNumber(val) }

  // Currency conversion helper for template display / 模板中货币转换辅助函数
  cvt(price) {
    const _currency = this.currentCurrency // eslint-disable-line no-unused-vars
    return convertPrice(price)
  }

  // Translation helper / 翻译辅助函数
  t(key, fallback) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  // Localized product helpers / 本地化产品辅助函数
  getLocalizedProductName(product) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedField(product, 'name') || product.name
  }

  getLocalizedProductDesc(product) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedField(product, 'description') || product.description
  }

  getLocalizedProductImage(product) {
    const _lang = this.currentLanguage // eslint-disable-line no-unused-vars
    return getLocalizedField(product, 'image') || product.image
  }

  // AI 推荐显示 reason，手动推荐不显示 description（保持空）
  getRecommendDescription(item) {
    if (!item._aiSource) return ''
    const showReason = this.venueSettings && this.venueSettings.aiRecommendation && this.venueSettings.aiRecommendation.showReasonText
    return showReason ? (item.reason || '') : ''
  }

  warningIcon = require('@/assets/tab-pics/warning-icon.png')
  showOrderType = true
  // Allergy prompt box switch
  // 过敏提示框的开关
  showAllergyDialog = false
  // Whether to pre fill in the membership code
  // 是否预填写会员码
  isFilledCode = false

  showEnablePayShortCutDialogSettings = {
    title: t('add_to_tab', 'Add it to your tab?'),
    firstButtonText: t('ok', 'OK'),
    secondButtonText: t('pay_another_way', 'PAY ANOTHER WAY'),
  }

  showDisablePayShortCutDialogSettings = {
    title: t('order_exceed_tab_limit', 'This order will exceed your tab limit'),
    content: t('increase_limit_or_pay', 'Please increase your limit or pay another way.'),
    firstButtonText: t('manage_my_tab', 'MANAGE MY TAB'),
    secondButtonText: t('pay_another_way', 'PAY ANOTHER WAY'),
  }

  showEnablePayShortCutDialog = false
  showDisablePayShortCutDialog = false
  showMemberInput = ''
  verifyMemberState = null // 1-pass 2-fail   // 1-通过 2-不通过
  memberInfo = {
    memberName: '',
    memberNum: '',
  }

  ls = []
  recommendProductList = []

  height = '46'
  // Form authentication
  // 表单验证
  valueFields = {
    tableId: '',
  }

  ruleValidate = {
    tableId: [
      {
        required: true,
        message: t('select_table_zone', 'Please select your table number/zone'),
        trigger: 'blur',
      },
      {
        validator: this._tableNumValidate,
        trigger: 'blur'
      },
    ],
  }

  isIOS = isIOS()
  status = 3
  inTouched = false
  outTouched = false
  comment = ''
  routerName = ''
  tableExtra = null
  tableExtraErrorText = ''
  timer = null
  deliveryInfo = {}
  venueSettings = null
  condition = null
  conditionBaseFee = 0
  minDeliveryAmount = 0
  tableList = [] // Table number list   // 桌号列表
  oldDeliveryBaseFee = 0 // Delivery fee before clicking the submit button   // 点击提交按钮前的外卖配送费
  // Anaphylaxis prompt
  // 过敏提示语
  allergyText = ''

  // Whether to verify the membership code
  // 是否验证会员码
  isMembership = false

  // Fill in the data when the membership code has value
  // 会员码有值时的数据
  isMemberData = {
    memberName: '',
    memberNum: '',
  }

  // Whether the allergic pop-up box is opened through the member code
  // 过敏弹框是否是通过会员码打开的
  isMemberCode = false

  /**
   * Format table name for display (converts Row to Seat in SP mode)
   * 格式化桌号显示（在 SP 模式下将 Row 转换为 Seat）
   * @param {String} name Original table name
   * @returns {String} Formatted table name for display
   */
  formatTableDisplayName(name) {
    if (!name || !this.shouldUseSpTableDisplay) {
      return name || ''
    }
    // Replace "Row" with "Seat" for display only (case insensitive)
    // 仅在显示时将 "Row" 替换为 "Seat"（不区分大小写）
    return name.replace(/\bRow\b/gi, 'Seat')
  }

  // Close the allergy prompt box
  // 关闭过敏提示框
  closeAllergyDialog() {
    this.showAllergyDialog = false
    if (this.isMemberCode) {
      setTimeout(this.memberCodeClick, 500)
    }
    this.$store.commit('saveAlcoholButton', true)
  }

  // Close member code copy
  // 关闭会员码文案
  memberCodeClick() {
    this.isMemberCode = false
    this.allergyText = t('allergy_warning', 'Before placing your order, please inform our staff if a person in your party has a food allergy.')
  }

  // Recall getTableExtra
  // 重新调取 getTableExtra
  anewGetTableExtra(val) {
    // Clear the form error message after entering the table number
    // 输入桌号后，清空表单的错误信息
    this.$refs.form.fields[0]._clearValidate()
    // Save table number to vuex
    // 保存桌号到 vuex
    this.$store.commit('saveTable', val)
    this.$store.commit('saveRouterInfo', {
      prop: 'number',
      val: val
    })
    if (!this.venueIsGuests) return
    // Anti shake
    // 防抖
    if (this.timer) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this._getTableExtra()
      this.timer = null
    }, 500)
  }

  showOrderTypeDialog() {
    if (this.$route.query.cleanLaterTime) {
      this.$refs.deliverInfoDialog._initScheduledTime()
    }
    this.$refs.deliverInfoDialog._show()
    // In case of non business hours, only "LATER" will be displayed
    // 如果是非营业时间，只展示 "LATER"
    if (!this.isVenueOpenTime) this.$refs.deliverInfoDialog.scheduledTime = 1
    this._cleanUrlQuery(['cleanLaterTime', 'openDeliveryInfo'])
  }

  clickVerifyMemberNum(data) {
    // Save Click Member Verification to save the time
    // 保存点击会员验证后，把时间保存
    this.memberInfo = data // Change memberInfo by component value transfer   // 通过组件传值改变 memberInfo
    this.$store.commit('saveDiscountRuleTime')
    this.verifyMemberNum()
  }

  /**
   * Real time assignment, listening to user member code filling
   * @param {Object} data Membership code information
   */
  /**
   * 实时赋值，监听用户的会员码填写
   * @param {Object} data 会员码信息
   */
  isMemberInfo(data) {
    this.isMemberData = data
    this.verifyMemberState = null
  }

  // Verify membership code
  // 验证会员码
  async verifyMemberNum() {
    const productList = JSON.parse(JSON.stringify(this.proList))
    // If memberForm is not rendered on the page, stop running
    // 若 memberForm 没有在页面渲染，则停止运行
    // if (!(this.$refs.memberForm)) return
    let code = this.memberInfo.memberNum.trim()
    if (!this.isCodeDiscount) {
      code = this.memberInfo.memberName.trim() + '|' + code
    }
    this.$store.commit('showLoading')
    const type = this.isCodeDiscount ? 'code' : 'sp'
    // Type temporarily defaults to sp
    // type 暂时默认为 'sp'
    const res = await verifyDiscount({
      venueId: this.venueId,
      type,
      code,
      details: null,
      email: this.userInfo.email,
      userId: this.userInfo.id,
      productList: this.$store.getters.itemList(this.venueId)
    }).catch((error) => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    this.verifyMemberState = res.success ? 1 : 2
    // Deep copy of the shopping cart's product list, used to calculate preferential prices
    // 深拷贝购物车的商品列表，用于计算优惠价格
    if (res.success) {
      this.$store.commit('useMemberRules', {
        productList,
        rules: res.rules,
        server: res.server ?? false,
        afterDiscountResult: res.afterDiscountResult ?? null,
        code,
      })
    }
    // After the judgment, drop verifyCouponCode from the url (without a jump), so a refresh doesn't verify again
    // 判断之后就把 verifyCouponCode 从 url 去掉（不跳转），刷新之后不再带它。
    // 多版本菜单 N35（review R4B5-1）：按键去掉、改写当前这一条（replaceState），别的参数逐字节不动。原来用字符串删「?verifyCouponCode=true」
    // 连问号一起删：它后面跟着的进店参数 / 点单链接码（&menuLink=…&mmEntry=…）就粘进了路径（/cart/t/7&mmEntry=table），刷新 / 后退回这一条时
    // 桌号成了整串、写进订单。原来还用 pushState 多压一条（后退第一下落在同一页），一并改成 replaceState
    const withoutCoupon = withoutQueryKeys(window.location.href, ['verifyCouponCode'])
    if (withoutCoupon !== window.location.href) window.history.replaceState(window.history.state, '', withoutCoupon)
    this.$store.commit('closeLoading')
  }

  setDeliveryInfo() {
    this.deliveryInfo =
        this.$store.state?.contactDetails?.deliveryInfo[this.venueId]
  }

  /**
   * Clear url query parameter
   * @param keyList {Array} List of parameter names
   */
  /**
   * 清除 url query 参数
   * @param keyList {Array} 参数名列表
   */
  _cleanUrlQuery(keyList) {
    let isPass = false
    const newQuery = JSON.parse(JSON.stringify(this.$route.query))
    for (const key of keyList) {
      if (newQuery[key]) {
        isPass = true
        delete newQuery[key]
      }
    }
    if (isPass) this.$router.replace({ query: newQuery })
  }

  // Get table related information
  // 获取 table 相关信息
  async _getTableExtra() {
    this.$store.commit('showLoading')
    const res = await getTableExtra({
      venueId: this.venueId,
      tableNo: this.valueFields.tableId ? this.valueFields.tableId : '',
    }).catch((error) => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    this.tableExtra = res
    this.$store.commit('closeLoading')
  }

  _saveOrderInfo(orderInfo) {
    // @todo decide to save orderInfo or not
  }

  _getUnPaidOrderInfo() {
    let unPaidOrderId
    let unPaidOrderNo
    const index = this.$store.state.venueUnpaidOrderList.findIndex(
      (item) => item.venueId === this.venueId,
    )
    if (index !== -1) {
      unPaidOrderId =
          this.$store.state.venueUnpaidOrderList[index].unPaidOrderId
      unPaidOrderNo =
          this.$store.state.venueUnpaidOrderList[index].unPaidOrderNo
    }
    return [unPaidOrderId, unPaidOrderNo]
  }

  async _updateTabAmountLimit() {
    await updateTab({
      venueId: this.venueId,
      tabId: this.tabInfo.currentTab.id,
      passCode: this.tabInfo.currentTab.phone.slice(-4),
      action: 'increaseTabAmount',
      detail: {
        tabAmount: parseFloat(
          _numberUpFixed(this.tabInfo.currentTab.tabAmount + this.totalAll),
        ),
      },
      fromPayment: true,
    }).catch((error) => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
  }

  @vuexStoreLoading
  async handleShortCutDialogOkButton() {
    // Vuex sets the corresponding orderType
    // vuex 设置对应的 orderType
    const orderType = this.inTouched ? 'dine-in' : 'takeaway'
    this.$store.commit('addDetailsProp', {
      prop: 'orderType',
      val: orderType,
    })
    if (!this.tabInfo.currentTab.isSetTabAmount) {
      await this._updateTabAmountLimit()
    }
    const [unPaidOrderId, unPaidOrderNo] = this._getUnPaidOrderInfo()
    if (this.isPostPaid) {
      if (unPaidOrderId && unPaidOrderNo) {
        await this.handleUnpaidOrderPostPaidTabOrder(
          unPaidOrderId,
          unPaidOrderNo,
        )
      } else {
        await this.handleNewOrderPostPaidTabOrder()
      }
    } else {
      let orderInfo
      if (unPaidOrderId && unPaidOrderNo) {
        orderInfo = await this._createTabPayOrder(0, unPaidOrderId)
      } else {
        orderInfo = await this._createTabPayOrder(0)
      }
      // 没下成（拒单已经由拦截器 / 「菜单刚更新」弹窗提示过）⇒ 停在购物车（多版本菜单 B6 U-B6-2，research §1.4；以前在 orderInfo.id 上抛 TypeError）。
      // 不知道下没下成（断网 / 超时 / 5xx）也停，两支都是（review 第 2 轮 G1）：带未付单 id 的那支在后端是**整单替换**那张未付单，不是追加 ——
      // 预付单落库恒为 NORMAL / PRE_ORDER，复用时按订单 type 走「pre-paid, just replace it」（AddOrderForm::addOrder），item_list / amount 整份换成这次的购物车，
      // 顾客再点一次只是用同一个购物车再换一次。去付那张未付单反而可能按它没换成功时的旧内容扣挂账。改动前（4a46a09f）这里也是停（TypeError）
      if (!isPlacedOrder(orderInfo)) return
      this._saveOrderInfo(orderInfo)
      await this._payTabPayOrder(orderInfo.id)
      this._clearProductListAndUnpaidOrder()
      this._jumpToTabOrderReceivedPage(orderInfo.id, orderInfo.orderNo)
    }
  }

  async handleUnpaidOrderPostPaidTabOrder(unPaidOrderId, unPaidOrderNo) {
    const orderInfo = await this._createTabPayOrder(2, unPaidOrderId)
    // 后端明确说没追加上 ⇒ 停在购物车：不清车、不拿 payWithTab 付掉那张老挂账单、不跳页（以前三样照做）。
    // 不知道追加上没有（断网 / 超时 / 5xx）⇒ 照改动前往下走（owner D1 = A）：追加在后端没有幂等，留在购物车让顾客再点一次会把同样的东西追加两遍；
    // 付的是服务器上那张单此刻的样子，跳过去看到的也是它
    if (orderOutcomeOf(orderInfo) === ORDER_NOT_PLACED) return
    this._clearProductListAndUnpaidOrder()
    await this._payTabPayOrder(unPaidOrderId)
    this._jumpToTabOrderReceivedPage(unPaidOrderId, unPaidOrderNo)
  }

  async handleNewOrderPostPaidTabOrder() {
    const orderInfo = await this._createTabPayOrder(2)
    // 没下成 ⇒ 停在购物车（以前先清了车，再在 orderInfo.id 上抛 TypeError）
    if (!isPlacedOrder(orderInfo)) return
    this._clearProductListAndUnpaidOrder()
    await this._payTabPayOrder(orderInfo.id)
    this._jumpToTabOrderReceivedPage(orderInfo.id, orderInfo.orderNo)
  }

  _clearProductListAndUnpaidOrder() {
    this.$store.commit('clearDiscounts')
    this.$store.commit('clearProductList')
  }

  async _createTabPayOrder(type = 0, orderId = '') {
    const state = this.$store.state
    // 先算 amount 再拼请求：重判费率会顺带更新 state.details（surchargeRate），不靠对象字面量里键的先后（review 第 1 轮 #8）
    const amount = orderAmountNow(this.$store, this.venueId)
    const data = {
      amount,
      subtotal: this.$store.getters.total(this.venueId),
      currency: state.currency,
      details: {
        ...state.details,
        baseFee: this.baseFee,
        minDeliveryAmount: this.minDeliveryAmount,
      },
      type,
      user: {
        ...state.contactDetails.user,
        id: localStorage.getItem('userId'),
        language: this.$store.state.language?.currentLanguage || 'en',
        currency: this.$store.state.currencySettings?.currentCurrency || '',
      },
      venueId: state.venueId,
      itemList: this.addItemList,
      spDiscounts: this.spDiscounts,
      creatorType: 'qr',
      menuType: state.app.menuType
    }
    if (this.$store.state.cart.includeAlcohol) {
      data.details.over18 = true
    }
    if (orderId) data.orderId = orderId
    if (this.isOnline) {
      const deliveryInfo = this.deliveryInfo
      data.type = deliveryInfo.type
      data.user.address = deliveryInfo.rawAddress
      data.details.orderType = deliveryInfo.orderType
      data.details.googleDeliveryTime =
          deliveryInfo?.deliveryCost?.timeCost ?? deliveryInfo.googleDeliveryTime
      data.details.preOrderTimeSettings =
          deliveryInfo.preOrderTimeSettings &&
          deliveryInfo.preOrderTimeSettings !== 'Invalid Date'
            ? deliveryInfo.preOrderTimeSettings
            : ''
    }
    return await addOrder(withOrderMenu(data, this.$store.state.menuId, menuEntry(this.$store.state, this.$route))).catch((error) => {
      console.log(error)
      this.$store.commit('closeLoading')
      // 不是一张单（调用方据此停住）；记着是后端明确拒了还是不知道下没下成（多版本菜单 B6 U-B6-2 review 第 1 轮 F1）
      return failedOrder(error)
    })
  }

  async _payTabPayOrder(orderId) {
    return await payOrder({
      id: orderId,
      paymentInfo: {
        type: 'payWithTab',
        tabCode: this.tabInfo.currentTab.tabCode,
      },
    }).catch((error) => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
  }

  _jumpToTabOrderReceivedPage(orderId, orderNo) {
    const isPass = this._checkEnvironmentalData()
    if (!isPass) return
    this.$router.push({
      path: `/v/${this.venueId}/tab-order-received/${orderId}`,
      query: {
        orderId,
        orderNo,
        isMarketing: 1,
      },
    })
  }

  /**
   * 检查环境数据
   * @returns {Boolean} 是否检查成功
   */
  _checkEnvironmentalData() {
    // 是否通过检查
    let isPass = true
    const { orderType } = this.$store.state.details
    const isTakeaway = this.$route.path.includes('/v/o/') || this.$route.path.includes('/online/')
    // table 环境
    if (this.$route.name === 'cart-table' || this.$route.name === 'venue-home-table') {
      const num = this.number || ''
      // 若不存在 tbale 数据，弹窗提示
      if (!(safeDecodeURI(num) || this.table)) {
        isPass = false
      }
    } else if (isTakeaway && this.$route.query.portal === 'true' && (this.$route.query.ta === null || this.$route.query.ta === undefined)) { // takeaway 环境
      if (orderType !== 'takeaway') {
        isPass = false
      }
    } else if (this.$route.query.portal === 'true') { // counter 环境
      if (orderType !== 'dine-in') {
        isPass = false
      }
    }
    // 检查不通过的时候，弹窗提醒
    if (!isPass) {
      MessageDialog.$create({
        content: t('session_expired', 'Your session has expired. Please scan the QR code to start your new order.')
      }).show()
    }
    return isPass
  }

  // 接收 3 个数组，去掉 arr 中包含 brr 和 crr 的对象
  deleteDuplicate(arr, brr, crr) {
    const c = []
    const y = []
    arr.forEach((item) => {
      const check = brr.every(function (b) {
        return item.name !== b.name
      })
      if (check) {
        c.push(item)
      }
    })
    c.forEach((item) => {
      const check = crr.every(function (b) {
        return item.name !== b.name
      })
      if (check) {
        y.push(item)
      }
    })
    return y
  }

  handleShortCutDialogPayAnotherPayButton() {
    this._coreHandlePlaceOrderButton()
  }

  handleShortCutDialogManageMyTabButton() {
    this._setTabPassCode()
    this._jumpToManageTab()
  }

  _setTabPassCode() {
    const passCode = this.tabInfo.currentTab.phone.slice(-4)
    this.$store.commit('tabPassCode/SET_TAB_PASS_CODE', passCode)
  }

  _jumpToManageTab() {
    const isPass = this._checkEnvironmentalData()
    if (!isPass) return
    this.$router.push({
      path: `/v/${this.venueId}/tab-admin/${this.tabInfo.currentTab.id}/menu`,
    })
  }

  async _filterAndSaveUnfinishOrder() {
    // filter and save unOverOrders
    if (this.userId) {
      await this._updateUnfinishOrders()
    } else {
      this.$store.commit('clearUnpaidOrder', this.venueId)
    }
  }

  async _updateUnfinishOrders() {
    const orders = await this._getUserUnOverOrders('nostart_all')
    const ordersTotal = parseInt(orders.total)
    if (ordersTotal > 0) {
      const filtersOrder = orders.orders.filter((item) => {
        if (item.paymentStatus === 0 && item.status <= 40) {
          return item
        }
      })
      if (filtersOrder.length > 0) {
        const order = filtersOrder[0]
        this._updateVenueUnpaidOrderList(order.id, order.orderNo)
      } else {
        this.$store.commit('clearUnpaidOrder', this.venueId)
      }
    } else {
      this.$store.commit('clearUnpaidOrder', this.venueId)
    }
  }

  _updateVenueUnpaidOrderList(orderId, orderNo) {
    this.$store.commit('saveVenueUnpaidOrderList', {
      venueId: this.venueId,
      unPaidOrderId: orderId,
      unPaidOrderNo: orderNo,
    })
  }

  async _getUserUnOverOrders(type) {
    const res = await getUserOrders({
      venueId: this.venueId,
      id: this.userId,
      type: type,
      pageSize: 5,
      pageNo: 1,
    }).catch((error) => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    return res
  }

  addListen() {
    if (!this.isIOS) {
      const dom =
          document.getElementById('textArea').children[0] ||
          document.getElementById('textArea')
      dom.addEventListener('focus', function () {
        // Top: 3000 means infinity
        // top: 3000 的意思是无穷大
        window.scrollTo({
          top: 3000,
          left: 100,
          behavior: 'smooth',
        })
      })
    }
  }

  getHight() {
    if (!this.isIOS && this.isMobile) {
      window.scrollTo({
        top: 3000,
        left: 100,
        behavior: 'smooth',
      })
    }
    const textArea =
        document.getElementById('textArea').children[0].scrollHeight
    console.log(this.ls[this.ls.length - 2])
    if (this.ls.includes(textArea)) {
    } else {
      const max = Math.max(...this.ls)
      if (textArea > max) {
        this.ls.push(textArea)
        if (textArea <= 40) {
          this.height = 40
        } else {
          this.height = textArea
        }
      } else {
        console.log('small')
        this.ls.splice(this.ls.length - 1, 1)
        this.height = this.ls[this.ls.length - 1] || 40
      }
    }
  }

  _validate(value) {
    return !!value
  }

  _tableNumValidate(rule, value, callback) {
    const res = this._validate(value)
    if (res) {
      if (
        this.$store.state.venueId === '4380f789-c561-4dc7-a510-6f9a48fbb3b9' &&
          !this.isOnline
      ) {
        const matches = value.match(/^(table |zone ){0,1}(\d+)$/i)
        let errorM = 'Please input table number under 50'
        if (!matches) {
          callback(new Error(errorM))
        } else {
          if (
            matches[1] === undefined ||
              matches[1].toLowerCase() === 'table '
          ) {
            if (parseInt(matches[2]) > 50) {
              callback(new Error(errorM))
            }
          } else {
            if (parseInt(matches[2]) > 5) {
              errorM = 'Please input zone number under 5'
              callback(new Error(errorM))
            }
          }
        }
      }
    }
    if (!res) {
      callback(new Error('Please input table number/name'))
    } else {
      callback()
    }
  }

  _getNumber() {
    const num = this.number || ''
    if (num === NO_INPUT_TABLE_NUMBER || num === '') {
      this.valueFields.tableId = ''
    } else {
      this.valueFields.tableId = safeDecodeURI(num) || this.table
    }
  }

  async _coreHandlePlaceOrderButton() {
    let res = true
    // Judge whether there are expired products
    // 判断是否有过期商品
    if (this.isOnline) res = await this._isExpire()
    if (this.isOnline && !res) {
      this.$store.commit('closeLoading')
      return
    }
    if (this.baseFee !== this.oldDeliveryBaseFee) {
      const message = MessageDict.delinery
      MessageDialog.$create({
        $props: {
          ...message,
          title: t('delivery_fee_changed', 'The delivery fee is changed'),
          content: t('delivery_fee_changed_content', 'We have changed the amount of your order. Please place the order again.'),
          buttonText: t('ok', 'OK')
        },
      }).show()
      this.$store.commit('closeLoading')
      return
    }

    this.$store.commit('showLoading')

    if (this.isPostPaid) {
      const index = this.$store.state.venueUnpaidOrderList.findIndex(
        (item) => item.venueId === this.venueId,
      )
      if (index !== -1) {
        const unPaidOrderNo =
            this.$store.state.venueUnpaidOrderList[index].unPaidOrderId
        const unPaidOrderId =
            this.$store.state.venueUnpaidOrderList[index].unPaidOrderNo
        await this.jumpToOrder(unPaidOrderId, unPaidOrderNo)
      } else {
        this.jumpToContactDetail()
      }
    } else {
      this.jumpToContactDetail()
    }
    this.$store.commit('closeLoading')
  }

  // Whether there are expired products
  // 是否有过期商品
  async _isExpire() {
    if (this.deliveryInfo.orderType === 'delivery') {
      const isPass = await this._verifyUserPostcode()
      if (!isPass) {
        this.$createTabMessageDialog({
          $props: delineryAddress,
        }).show()
        return
      }
    }
    const state = this.$store.state
    // 先算 amount 再拼请求：重判费率会顺带更新 state.details（surchargeRate），不靠对象字面量里键的先后（review 第 1 轮 #8）
    const amount = orderAmountNow(this.$store, this.venueId)
    const data = {
      amount,
      subtotal: this.$store.getters.total(this.venueId),
      currency: state.currency,
      details: {
        ...state.details,
        googleDeliveryTime:
            this.deliveryInfo?.deliveryCost?.timeCost ??
            this.deliveryInfo.googleDeliveryTime,
        orderType: this.deliveryInfo.orderType,
        preOrderTimeSettings: this.deliveryInfo.preOrderTimeSettings,
        baseFee: this.baseFee,
        minDeliveryAmount: this.minDeliveryAmount,
      },
      type: this.deliveryInfo.type,
      user: {
        id: null,
        name: null,
        email: state.contactDetails?.user?.email ?? null,
        phone: null,
        joinMarketingConsent: null,
        address: this.deliveryInfo.rawAddress,
        language: this.$store.state.language?.currentLanguage || 'en',
        currency: this.$store.state.currencySettings?.currentCurrency || '',
      },
      venueId: state.venueId,
      itemList: this.addItemList,
      spDiscounts: this.spDiscounts,
      creatorType: 'qr',
      menuType: state.app.menuType
    }
    const res = await addOrder(withOrderMenu(data, this.$store.state.menuId, menuEntry(this.$store.state, this.$route))).catch((error) => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    return res
  }

  // Verify whether the delivery address has changed
  // 校验外卖地址是否发生变化
  async _verifyUserPostcode() {
    let isPass = false
    const rawAddress = JSON.parse(this.deliveryInfo.rawAddress)
    const { address_components } = rawAddress
    let postcode
    address_components.forEach((address) => {
      if (address.types && address.types.includes('postal_code')) {
        postcode = address.short_name
      }
    })
    if (postcode) {
      const venueInfo = await getVenue({
        id: safeDecodeURI(this.$route.params.venueId),
      }).catch((error) => {
        console.log(error)
        this.$store.commit('closeLoading')
      })
      let postcodes =
          venueInfo?.settings?.deliverySettings?.areaSettings?.postcodes ?? []
      if (postcodes?.length) {
        postcodes = postcodes.map((item) => ({
          ...item,
          zone: item?.name ?? item.zone,
          postcode: item?.postalcode ?? item.postcode,
        }))
      }
      isPass = !!postcodes.find((item) => item.postcode === postcode)
    }
    return isPass
  }

  // Additional order
  // 追加订单
  async AddOrder(unPaidOrderId) {
    const state = this.$store.state
    // 先算 amount 再拼请求：重判费率会顺带更新 state.details（surchargeRate），不靠对象字面量里键的先后（review 第 1 轮 #8）
    const amount = orderAmountNow(this.$store, this.venueId)
    const data = {
      amount,
      subtotal: this.$store.getters.total(this.venueId),
      currency: state.currency,
      details: {
        ...state.details,
        baseFee: this.baseFee,
        minDeliveryAmount: this.minDeliveryAmount,
      },
      type: 2,
      user: {
        ...state.contactDetails.user,
        id: localStorage.getItem('userId'),
        language: this.$store.state.language?.currentLanguage || 'en',
        currency: this.$store.state.currencySettings?.currentCurrency || '',
      },
      venueId: state.venueId,
      itemList: this.$store.getters.itemList(this.venueId),
      orderId: unPaidOrderId,
      spDiscounts: this.spDiscounts,
      creatorType: 'qr',
      menuType: state.app.menuType
    }
    if (this.$store.state.cart.includeAlcohol) {
      data.details.over18 = true
    }
    if (this.isOnline) {
      const deliveryInfo = this.deliveryInfo
      data.type = deliveryInfo.type
      data.user.address = deliveryInfo.rawAddress
      data.details.orderType = deliveryInfo.orderType
      data.details.googleDeliveryTime =
          deliveryInfo?.deliveryCost?.timeCost ?? deliveryInfo.googleDeliveryTime
      data.details.preOrderTimeSettings =
          deliveryInfo.preOrderTimeSettings &&
          deliveryInfo.preOrderTimeSettings !== 'Invalid Date'
            ? deliveryInfo.preOrderTimeSettings
            : ''
    }
    const res = await addOrder(withOrderMenu(data, this.$store.state.menuId, menuEntry(this.$store.state, this.$route))).catch((error) => {
      console.log(error)
      this.$store.commit('closeLoading')
      // 不是一张单；记着是后端明确拒了还是不知道追加上没有（多版本菜单 B6 U-B6-2 review 第 1 轮 F1）
      return failedOrder(error)
    })
    return res
  }

  async jumpToOrder(unPaidOrderNo, unPaidOrderId) {
    console.log(unPaidOrderId, unPaidOrderNo)
    try {
      const orderInfo = await this.AddOrder(unPaidOrderId)
      // 后端明确说没追加上 ⇒ 停在购物车（不清车、不跳页），拒单由拦截器 / 「菜单刚更新」弹窗提示（多版本菜单 B6 U-B6-2）。
      // 不知道追加上没有（断网 / 超时 / 5xx）⇒ 照改动前清车、去那张未付单的页面看服务器上的样子（owner D1 = A：追加没有幂等，再点一次会追加两遍）
      if (orderOutcomeOf(orderInfo) === ORDER_NOT_PLACED) return
      this.clearProductList()
      this.jumpToPostPay(unPaidOrderId, unPaidOrderNo)
    } catch (e) {
      console.log(e)
    }
  }

  jumpToPostPay(orderId, orderNo) {
    const isPass = this._checkEnvironmentalData()
    if (!isPass) return
    this.$router.push({
      path: `/v/${this.venueId}/pay/${orderId}`,
      query: {
        orderNo: orderNo,
      },
    })
  }

  clearProductList() {
    this.$store.commit('clearDiscounts')
    this.$store.commit('clearProductList')
  }

  checkCurrentTabOwner() {
    // 多版本菜单 B6（U-B6-3）：菜单预览页不能下单（按钮已变灰；这里兜住按钮状态还没更新的那一下）—— 不进任何下单 / 挂账 / 付款分支
    if (stopOrderingForPreview(this.$route)) return
    // The user enters the membership code and there is no verification pop-up prompt box
    // 用户输入会员码时，并且没有校验弹出提示框
    if ((this.isMemberData.memberName !== '' || this.isMemberData.memberNum !== '') && this.verifyMemberState === null) {
      this.allergyText = t('verify_coupon_code', 'Please verify your coupon code for your discount to apply.')
      this.showAllergyDialog = true
      this.isMemberCode = true
      return
    }
    this.oldDeliveryBaseFee = this.baseFee
    const isTakeaway = this.$route.path.includes('/v/o/') || this.$route.path.includes('/online/')
    if (this.isTabOwner && this.isPrePaidOrder && !this.isOnline && !isTakeaway) {
      this.__checkVenueTodayIsOpenTime(this._shortCutAddOrder)
    } else {
      this.__checkVenueTodayIsOpenTime(this.validateAndSaveInfo)
    }
  }

  // Get the latest third-party distribution information
  // 获取最新的第三方配送信息
  async _setDeliveryCost() {
    if (this.isOnline &&
        (this.venueSettings?.deliverySettings?.type ?? 'local') !== 'local' &&
        this.deliveryInfo.orderType === 'delivery'
    ) {
      await this.$refs.deliverInfoDialog._getDeliveryCost()
      await this.$refs.deliverInfoDialog._setDeliveryInfo(this.vuexDeliveryInfo, false)
      await this.$refs.deliverInfoDialog._addDeliveryInfo()
    }
  }

  _shortCutAddOrder() {
    // Save comment first
    // 先保存 comment
    this.saveComment(this.comment)
    // These two steps are priority
    // 这两步是优先的
    this._checkIncludeAlcohol()

    if (
      this.number ||
        this.venueId === 'b81621f1-5c82-4b97-98dd-93d7b9cdd106' ||
        this.venueId === 'fdcc96f2-c145-4dc4-9c6e-8027b4b9c55b' ||
        (this.venueId === '4380f789-c561-4dc7-a510-6f9a48fbb3b9' &&
            !this.isOnline) ||
        (this.$store.state.forceTableInput && !this.isOnline)
    ) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$store.commit('showLoading')
          this.saveTable(this.valueFields.tableId)
          this._decideUseShortCutOrderPayment()
        } else {
          this.$store.commit('closeLoading')
          // scroll to top
          window.scrollTo({
            top: 0,
            left: 100,
            behavior: 'smooth',
          })
        }
      })
    } else {
      this._decideUseShortCutOrderPayment()
    }
  }

  _decideUseShortCutOrderPayment() {
    const leftPriceAmount =
        this.tabInfo.currentTab.tabAmount - this.tabInfo.currentTab.amount
    const enoughMoneyLeft = this.totalAll <= leftPriceAmount
    const enablePay = enoughMoneyLeft || !this.tabInfo.currentTab.isSetTabAmount
    if (enablePay) {
      this.showEnablePayShortCutDialog = true
    } else {
      this.showDisablePayShortCutDialog = true
    }
    this.$store.commit('closeLoading')
  }

  validateAndSaveInfo() {
    // Save comment first
    // 先保存 comment
    this.saveComment(this.comment)
    // These two steps are priority
    // 这两步是优先的
    this._checkIncludeAlcohol()
    if (
      this.number ||
        this.venueId === 'b81621f1-5c82-4b97-98dd-93d7b9cdd106' ||
        this.venueId === 'fdcc96f2-c145-4dc4-9c6e-8027b4b9c55b' ||
        (this.venueId === '4380f789-c561-4dc7-a510-6f9a48fbb3b9' &&
            !this.isOnline) ||
        (this.$store.state.forceTableInput && !this.isOnline)
    ) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$store.commit('showLoading')
          this.saveTable(this.valueFields.tableId)
          this._coreHandlePlaceOrderButton()
        } else {
          this.$store.commit('closeLoading')
          // scroll to top
          window.scrollTo({
            top: 0,
            left: 100,
            behavior: 'smooth',
          })
        }
      })
    } else {
      this._coreHandlePlaceOrderButton()
    }
  }

  jumpToContactDetail() {
    const isPass = this._checkEnvironmentalData()
    if (!isPass) return

    if (this.$openreplayTracker) this.$openreplayTracker.event('begin_checkout')
    trackFunnelEvent('begin_checkout')
    if (this.$gtag) {
      this.$gtag.event('begin_checkout', {
        event_category: 'purchase_journey',
        event_label: 'Checkout - Contact Detail',
      })
    }
    this.$router.push(`/v/${this.venueId}/contact-details`)
  }

  _checkIncludeAlcohol() {
    const target = 'Alcohol'

    // First judge whether the product contains alcohol
    // 先判断商品中是否含有酒精
    let hasAlcohol = !!this._.find(this.proList, (pro) =>
      (pro.containsTags ?? []).find((tag) => tag === 'Alcohol'),
    )
    const comboList = this.proList.filter((pro) => pro.type === 'combo')
    // If the product does not contain alcohol and there is combo. Then check whether there is alcohol in the single product of combo
    // 若商品中没有含有酒精，并且存在 combo。则去 combo 的单品里，查看是否有含酒精
    if (!hasAlcohol && comboList.length) {
      // The field without containsTags is treated as an empty array
      // 没有 containsTags 这个字段时，按照空数组处理
      hasAlcohol = !!this._.find(comboList, (combo) =>
        this._.find(combo.comboProducts, (product) =>
          this._.find(product.itemList, (item) =>
            (item?.containsTags ?? []).find((tag) => tag === 'Alcohol'),
          ),
        ),
      )
    }
    this.$store.commit('checkIncludeAlcohol', Boolean(hasAlcohol))
  }

  saveTable(val) {
    this.$store.commit('addDetailsProp', {
      prop: 'table',
      val,
    })
    this.$store.commit('saveRouterInfo', {
      prop: 'number',
      val: val
    })
  }

  saveComment(val) {
    this.$store.commit('addDetailsProp', {
      prop: 'comment',
      val,
    })
  }

  inTouchedFun() {
    this.outTouched = false
    this.inTouched = true
    localStorage.setItem('orderType', '')
  }

  outTouchedFun() {
    this.outTouched = true
    this.inTouched = false
    localStorage.setItem('orderType', 'takeaway')
  }

  async _getVenue() {
    // SP 模式下添加 spMode 参数，以获取 spTableList
    const venueParams = {
      id: safeDecodeURI(this.$route.params.venueId),
    }
    if (this.isSpMode) {
      venueParams.spMode = true
    }
    const venueInfo = await getVenue(venueParams).catch((error) => {
      console.log(error)
      this.$store.commit('closeLoading')
    })
    this.venueSettings = venueInfo.settings
    // Member code pre filled
    // 会员码预填写
    const couponCodeList = this.venueSettings?.discountRules?.filter(item => {
      return (item.name === 'coupon code' && item.defaultApply)
    })
    if (couponCodeList[0]?.defaultApply) {
      this.memberInfo.memberNum = couponCodeList[0]?.code || ''
      this.isFilledCode = true
    }
    // SP 模式下使用 spTableList，否则使用 tables
    if (this.isSpMode && venueInfo.spTableList?.length) {
      this.tableList = venueInfo.spTableList
    } else {
      this.tableList = venueInfo.tables
    }
  }

  async _getCartRecommend() {
    if (this.proList.length > 0) {
      // 点单模式随请求带给后端：AI 购物车推荐按模式过滤（dine-in 不推 online-only
      // 商品，反之亦然）。优先用下单链路同源的 details.orderType；没有就按路由推断。
      // 后端对空/不认识的值不过滤，行为向后兼容
      const isTakeawayRoute = this.$route.path.includes('/v/o/') || this.$route.path.includes('/online/')
      const recommendOrderType = this.$store.state.details?.orderType ||
        ((this.isOnline || isTakeawayRoute) ? 'takeaway' : 'dine-in')
      // 多版本菜单 B6：带这家店此刻的菜单；菜单已不在用 ⇒ 静默重新解析一次再取（不弹窗、不循环）
      const routeVenueId = safeDecodeURI(this.$route.params.venueId)
      const readRecommend = () => otherAction(withMenuId({
        action: 'get_cart_recommend',
        cart: {
          products: this.proList,
          orderInfo: this.deliveryInfo,
          userInfo: this.userInfo
        },
        venueId: routeVenueId,
        groupId: '',
        id: routeVenueId,
        orderType: recommendOrderType,
        spMode: this.isSpMode
      }, menuIdFor(this.$store.state, routeVenueId)))
      const recommendList = await readWithMenuRetry(readRecommend, () => reresolveMenu(this.$store, {
        venueId: routeVenueId,
        query: this.$route.query,
        table: this.number,
        takeawayAllowed: this.venueSettings?.dineInSettings?.enableTakeaway !== false,
        route: this.$route
      })).catch((error) => {
        console.log(error)
      })
      if (Array.isArray(recommendList)) {
        // 必选配菜组里一样都选不了的商品：**不展示**（owner 2026-08-10 裁定）。
        // 与菜单列表（venue-home 的 controlProducts）同一个判据、同一个函数 ——
        // 推荐位这一条是独立取数，不过菜单那道门；漏了就会出现「菜单上没有、
        // 购物车里推给你、点进去还加不进来」。
        // 空数组也要赋值：后端按点单模式过滤后可以合法地返回空（2026-08-27 起），
        // 旧写法 length > 0 才赋值会把上一次（可能是错误模式下）的列表一直挂在页面上
        this.recommendProductList = recommendList.filter(product => !productHasUnpickableRequiredSection(product))
      }
    }
  }

  // 多版本菜单 B6（D97，U-B6-2）：进购物车页时 store 里的菜单与建车菜单不同（跨会话恢复出来的车、绕过首页的深链、
  // 商品页 / 推荐的静默重新解析）⇒ 取一次这份菜单的 get-product-list，把不在上面的行标出来、提示一句；不清车。
  // 只给 store 里那家店做（get-venue 还没回来、路由已经是别家店的那一下不做）。mounted 不等它（review 第 1 轮 F6），所以这里自己兜住一切错误。
  // 菜单预览地址不做（review 第 2 轮 G6）：这里的菜单是还没上线的草稿，拿它标真购物车（会存进 localStorage）、提示「菜单刚更新」、记建车菜单都不对
  async _recheckCartMenu() {
    if (isOrderingBlockedByPreview(this.$route)) return
    if (!isStoreVenue(this.$store.state, safeDecodeURI(this.$route.params.venueId))) return
    try {
      await recheckCartWithMenu(this.$store, { notify: () => createMessageDialog(menuChangedNoticeText()) })
    } catch (error) {
      console.log(error)
    }
  }

  addProductToCart(product) {
    // 复杂产品（combo / 有 modification / multi-size）跳转 product-detail
    const hasMultiSize = product.sizeSettings?.mutipleSize && product.sizeSettings?.settings?.length > 1
    const mods = product.modifications || []
    const hasMod = mods.length > 0
    const isCombo = product.type === 'combo' || (product.comboProducts && product.comboProducts.length > 0)
    if (hasMultiSize || hasMod || isCombo) {
      // AI 推荐产品跳转 product-detail，归因通过 sessionStorage 暂存（避免 URL 过长）
      if (product._aiSource && product._aiAttribution) {
        try {
          sessionStorage.setItem('aiRecommendAttribution_' + product.id, JSON.stringify(product._aiAttribution))
        } catch (e) { /* ignore */ }
      }
      // A/B test framework: stash manual recAttribution (if any) for product-detail to pick up.
      // A/B 测试框架：人工推荐归因暂存到 sessionStorage，让 product-detail 接收。
      if (product.recAttribution) {
        try {
          sessionStorage.setItem('pendingRecAttribution_' + product.id, JSON.stringify(product.recAttribution))
        } catch (e) { /* ignore */ }
      }
      this.$router.push({
        path: `/v/${this.venueId}/product/p/${product.id}`,
        query: { fromCart: '1', aiSource: product._aiSource ? '1' : undefined }
      })
      return
    }

    const singlePrice = parseFloat(product.price) + parseFloat(product?.upgradeProducts?.items?.find(item => item.checked)?.price ?? 0)
    const selectSize = {
      default: null,
      name: null,
      price: null,
      shortName: null
    }
    const unPaidOrderNo = this.$store.state.venueUnpaidOrderList.find(item => item.venueId === this.venueId)?.unPaidOrderId ?? ''
    const isAddItem = this.routerInfo.paymentType === 'post-paid' && unPaidOrderNo
    const productAdd = {
      ...product,
      venueId: this.venueId,
      productGroupId: null,
      isAddItem: isAddItem,
      singlePrice,
      recommendFromProductId: null,
      aiRecommendFromProductId: product._aiSource ? product.id : '',
      aiRecommendScene: product._aiSource ? 'cart' : '',
      aiRecommendAttribution: product._aiSource ? (product._aiAttribution || null) : null,
      // A/B test framework: parallel attribution slot for manual recommendations.
      // A/B 测试框架：人工推荐的归因字段，和 aiRecommendAttribution 并列。
      recAttribution: product.recAttribution || null,
      productGroupCourse: null,
      selectSize: selectSize,
      comboProductList: [],
      num: 1
    }

    this.$store.commit('addNewProductToCart', productAdd)
  }
}

export default Order
</script>
